module.exports = __webpack_public_path__ + "media/images/global_map-04b6ae992df2f198a1fbb032d315eed6.png";